import { lazy } from 'react'

export const DailyWaterV1 = lazy(() => import('./v1/DailyWaterV1'))
export const DailyWaterV2 = lazy(() => import('./v2/DailyWaterV2'))
export const DailyWaterV3 = lazy(() => import('./v3/DailyWaterV3'))
export const KitDailyWaterV1 = lazy(() => import('./kitV1/KitDailyWaterV1'))
